import { useEffect } from "react";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { DivisionRuleTestRequest, DivisionRule } from "../../../../models";

import { StringDetailedResponse } from "../../../../models/swagger/generated-submission-service";
import { DivisionRulesService } from "../../../../services/ClientService";

export type DivisionRuleTestModalProps = {
    show: boolean;
    attorneyId?: string;
    countyName?: string;
    csvDivision?: string;
    ruleId?: string;
    filename?: string;
    fileText?: string;
    documentType?: string;
    feeName?: string;
    claimAmount?: number;
    data?: DivisionRule;
    onSubmit: () => void;
    onClose: () => void;
};

export default function DivsionRuleTestModal({
    show,
    attorneyId,
    countyName,
    csvDivision,
    claimAmount,
    onSubmit,
    onClose,
}: DivisionRuleTestModalProps) {
    const [rule, setRule] = useState({
        attorneyID: attorneyId,
        countyName: countyName,
        csvDivision: csvDivision,
        claimAmount: claimAmount,
    } as DivisionRuleTestRequest);

    const [data, setData] = useState("");

    useEffect(() => {
        setRule({
            attorneyID: attorneyId,
            countyName: countyName,
            csvDivision: csvDivision ?? "",
            claimAmount: claimAmount,
        });
    }, [show, attorneyId, countyName, csvDivision, claimAmount]);

    const submitRule = () => {
        DivisionRulesService.getRule({
            body: {
                ...rule,
            },
        }).then(
            (resp) => {
                // onSubmit();
                setData(JSON.stringify(resp.data));
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const closeWindow = () => {
        setData("");
        onClose();
    };

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Division Rule Test
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row form-group m-2">
                    <div className="col-sm-6">
                        <label>Attorney ID</label>
                        <input
                            className="form-control"
                            id="divisionRuleAttorneyID"
                            type="text"
                            defaultValue={rule.attorneyID}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    attorneyID: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                    <div className="col-sm-6">
                        <label>County</label>
                        <input
                            className="form-control"
                            id="divisionRuleCounty"
                            type="text"
                            defaultValue={rule.countyName}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    countyName: event.currentTarget.value,
                                })
                            }
                        />
                    </div>

                    <div className="col-sm-6">
                        <label>CSV Division</label>
                        <input
                            className="form-control"
                            id="divisionRuleCsvDivision"
                            type="text"
                            defaultValue={rule.csvDivision}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    csvDivision: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                    <div className="col-sm-6">
                        <label>Claim Amount</label>
                        <input
                            className="form-control"
                            id="divisionRuleClaimAmount"
                            type="number"
                            defaultValue={0}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    claimAmount: parseFloat(
                                        event.currentTarget.value
                                    ),
                                })
                            }
                        />
                    </div>
                </div>
                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>Result:</label>
                        <label>{data}</label>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-danger" onClick={closeWindow}>
                    Cancel
                </Button>
                <Button onClick={submitRule}>Submit</Button>
            </Modal.Footer>
        </Modal>
    );
}
